import { useQuery } from '@tanstack/react-query';
import { getCellPanels } from 'api/cellRules';
import { CellRuleStudyId } from 'interfaces/cellRule';

export const getCellRulePanelsKey = (studyId: CellRuleStudyId) => (studyId ? ['cellPanels', studyId] : ['cellPanels']);

const useCellRulePanels = (
  studyId: CellRuleStudyId,
  {
    enabled = true,
  }: {
    enabled?: boolean;
  } = {}
) => {
  const query = useQuery({
    queryKey: getCellRulePanelsKey(studyId),
    queryFn: () => getCellPanels(studyId),
    enabled,
  });
  return query;
};

export default useCellRulePanels;
